module.exports = __webpack_public_path__ + "img/loginPageBackground.f175b4ae.png";